import { Flex, Text } from '@chakra-ui/layout';
import { Button, Icon } from '@chakra-ui/react';
import AvatarsGroupMy from 'components/AvatarsGroupMy';
import CardMy from 'components/CardMy';
import { LuPlayCircle } from 'react-icons/lu';
import { RiTimerLine } from 'react-icons/ri';

const Recommendation = () => (
    <CardMy>
        <Flex gap="12px" alignItems="center">
            <Flex
                width="40px"
                height="40px"
                alignItems="center"
                justifyContent="center"
                borderRadius={'16px'}
                bg="orange.100"
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path
                        d="M17.6596 11.2C17.4296 10.9 17.1496 10.64 16.8896 10.38C16.2196 9.78 15.4596 9.35 14.8196 8.72C13.3296 7.26 12.9996 4.85 13.9496 3C12.9996 3.23 12.1696 3.75 11.4596 4.32C8.86956 6.4 7.84956 10.07 9.06956 13.22C9.10956 13.32 9.14956 13.42 9.14956 13.55C9.14956 13.77 8.99956 13.97 8.79956 14.05C8.56956 14.15 8.32956 14.09 8.13956 13.93C8.08281 13.8825 8.03534 13.8248 7.99956 13.76C6.86956 12.33 6.68956 10.28 7.44956 8.64C5.77956 10 4.86956 12.3 4.99956 14.47C5.05956 14.97 5.11956 15.47 5.28956 15.97C5.42956 16.57 5.69956 17.17 5.99956 17.7C7.07956 19.43 8.94956 20.67 10.9596 20.92C13.0996 21.19 15.3896 20.8 17.0296 19.32C18.8596 17.66 19.4996 15 18.5596 12.72L18.4296 12.46C18.2196 12 17.6596 11.2 17.6596 11.2ZM14.4996 17.5C14.2196 17.74 13.7596 18 13.3996 18.1C12.2796 18.5 11.1596 17.94 10.4996 17.28C11.6896 17 12.3996 16.12 12.6096 15.23C12.7796 14.43 12.4596 13.77 12.3296 13C12.2096 12.26 12.2296 11.63 12.4996 10.94C12.6896 11.32 12.8896 11.7 13.1296 12C13.8996 13 15.1096 13.44 15.3696 14.8C15.4096 14.94 15.4296 15.08 15.4296 15.23C15.4596 16.05 15.0996 16.95 14.4996 17.5Z"
                        fill="#ED8936"
                    />
                </svg>
            </Flex>
            <div>
                <Text color="gray.500" fontSize="12px">
                    Recommendation
                </Text>
                <Text color="gray.900" fontSize="14px" fontWeight={600} letterSpacing="-0.28px">
                    Tailored Sales Coaching
                </Text>
            </div>
            <AvatarsGroupMy />
        </Flex>
        <Text color="gray.900" fontSize="16px" letterSpacing="-0.32px" fontWeight="700" maxWidth="215px" mt="20px">
            Learn the keys to increasing your offer percentage.
        </Text>
        <Flex
            bg="brand.50"
            borderRadius="10px"
            alignItems="center"
            pl="16px"
            justifyContent="space-between"
            ml="-16px"
            mr="-16px"
            mb="-16px"
            mt="32px"
        >
            <Flex alignItems="center" gap="8px">
                <Icon as={RiTimerLine} width="16px" height="16px" color="brand.500" />
                <Text fontSize="14px" fontWeight="600" letterSpacing="-0.28px" color="gray.900">
                    85 mins
                </Text>
            </Flex>
            <Flex alignItems="center" gap="8px">
                <Icon as={LuPlayCircle} width="16px" height="16px" color="brand.500" />
                <Text fontSize="14px" fontWeight="600" letterSpacing="-0.28px" color="gray.900">
                    Video format
                </Text>
            </Flex>
            <Button variant="brand">Get Started</Button>
        </Flex>
    </CardMy>
);

export default Recommendation;
